import { TagGroupApiModel } from '../tag-group.api.model';

export class GadgetApiModel {
  itemId: string;
  name: string;
  description: string;

  price: number;
  taxRate?: number;

  customText1?: string;
  customText2?: string;
  customText3?: string;

  pictures?: string[];
  tagGroups?: TagGroupApiModel[];
}
